export enum IS32Locations {
  Room = 'Room',
  Bed1 = 'Bed1',
  Bed2 = 'Bed2',
  Bed3 = 'Bed3',
  Bed4 = 'Bed4',
  Bed5 = 'Bed5',
  Bed6 = 'Bed6',
  Bed7 = 'Bed7',
  Bed8 = 'Bed8',
  Toilet1 = 'Toilet1',
  Toilet2 = 'Toilet2',
  Toilet3 = 'Toilet3',
  Toilet4 = 'Toilet4',
  Toilet5 = 'Toilet5',
  Toilet6 = 'Toilet6',
  Toilet7 = 'Toilet7',
  Toilet8 = 'Toilet8',
}
